import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { ingredientId: Number, categoryId: Number }

  dragstart(event) {
    event.dataTransfer.effectAllowed = "move"
    const nameEl = this.element.querySelector("h3")
    const name = nameEl ? nameEl.textContent.trim() : ""

    event.dataTransfer.setData("application/json", JSON.stringify({
      ingredientId: this.ingredientIdValue,
      sourceCategoryId: this.categoryIdValue,
      name
    }))

    this.element.classList.add("opacity-50", "scale-95")
    document.querySelectorAll("[data-controller='pantry-drop-zone']").forEach(zone => {
      zone.classList.add("transition-colors")
    })
  }

  dragend(_event) {
    this.element.classList.remove("opacity-50", "scale-95")
    document.querySelectorAll("[data-controller='pantry-drop-zone']").forEach(zone => {
      zone.classList.remove("border-electric", "border-2", "bg-electric/10")
    })
  }
}
